class CuriositiesLeafs {
    constructor(module) {
        this.module = module
        this.leafs = this.module.querySelectorAll('.curiosities-leafs__leaf')
        this.container = this.module.querySelector('.container')
        this.header = this.module.querySelector('.section-header')
        this.sectionContainer = this.module.querySelector('.section-list-and-image')
        this.imageContainer = this.module.querySelector('.section-image-container')

        this.tl = gsap.timeline()
        this.mm = gsap.matchMedia()
        
        this.init()
    }

    init() {
        this.tl.to(this.leafs, {
            scrollTrigger: {
                trigger: this.imageContainer,
                end: () => {
                    let targetTop = this.header.getBoundingClientRect().top + window.scrollY - 140
                    if (window.innerWidth >= 1024) {
                        targetTop = this.container.getBoundingClientRect().top + window.scrollY + 400 - 123
                    }
                    return targetTop
                },
                scrub: true,
            },
            x: (i) => {
                const xExit = this.leafs[i].dataset.xExit || false
                return xExit
            },
            y: (i) => {
                const yExit = this.leafs[i].dataset.yExit || false
                return yExit
            },
            opacity: (i) => {
                if (window.innerWidth >= 1024) {
                    return this.leafs[i].dataset.opacityExit || 0
                } else {
                    return 0
                }
            },
        })

        this.tl.from(this.container, {
            scrollTrigger: {
                trigger: this.container,
                start: 'top 123px',
                end: '+=100',
                scrub: true,
            },
            opacity: 0,
        })

        ScrollTrigger.create({
            trigger: this.container,
            start: 'top center',
            onEnter: () => {
                let targetTop = this.header.getBoundingClientRect().top + window.scrollY - 140
                if (window.innerWidth >= 1024) {
                    targetTop = this.container.getBoundingClientRect().top + window.scrollY + 400 - 123
                }

                const preventScroll = (e) => e.preventDefault()
                window.addEventListener('wheel', preventScroll, { passive: false })
                window.addEventListener('touchmove', preventScroll, { passive: false })

                const scrollObj = { y: window.scrollY }
                gsap.to(scrollObj, {
                    y: targetTop,
                    duration: 2,
                    overwrite: 'auto',
                    onUpdate: () => window.scrollTo(0, scrollObj.y),
                    onComplete: () => {
                        window.removeEventListener('wheel', preventScroll)
                        window.removeEventListener('touchmove', preventScroll)
                    },
                    onInterrupt: () => {
                        window.removeEventListener('wheel', preventScroll)
                        window.removeEventListener('touchmove', preventScroll)
                    },
                })
            },
        })

        this.mm.add('(min-width: 1024px)', () => {
            ScrollTrigger.create({
                trigger: this.module,
                start: 'top top',
                end: 'bottom bottom',
                scrub: true,
                onUpdate: (self) => {
                    const section = Math.min(3, Math.floor(self.progress * 3) + 1)
                    if (this.sectionContainer) {
                        this.sectionContainer.setAttribute('data-section', section)
                    }
                },
            })
        })

        this.mm.add('(max-width: 1023px)', () => {
            ScrollTrigger.create({
                trigger: this.imageContainer,
                start: 'center 70%',
                end: 'center 70%',
                scrub: true,
                onLeave: (self) => {
                    this.sectionContainer.setAttribute('data-section', 2)
                },
                onEnterBack: (self) => {
                    this.sectionContainer.setAttribute('data-section', 1)
                },
            })
        })
    }
}

const initLeafs = () => {
    const leafSections = document.querySelectorAll('.curiosities-leafs')
    leafSections.forEach((section) => {
        new CuriositiesLeafs(section)
    })
}

const loadScript = (url, callback) => {
    const script = document.createElement('script')
    script.src = url
    script.onload = callback
    document.head.appendChild(script)
}

if (typeof gsap === 'undefined') {
    loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js', () => {
        loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js', () => {
            gsap.registerPlugin(ScrollTrigger)
            initLeafs()
        })
    })
} else if (typeof ScrollTrigger === 'undefined') {
    loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js', () => {
        gsap.registerPlugin(ScrollTrigger)
        initLeafs()
    })
} else {
    gsap.registerPlugin(ScrollTrigger)
    initLeafs()
}
